import React from "react";
import { Flower2 } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { SongRow } from "@/components/SongRow";
import { meheniSongs } from "@/lib/poya";

// A reverent Binara Poya tribute honouring women artists and nuns.
export const MeheniTribute = ({ songs }) => {
  const { t, fontClass } = useLang();
  const list = meheniSongs(songs);

  return (
    <section className="max-w-6xl mx-auto px-4 sm:px-6 pt-10" data-testid="meheni-tribute">
      <div className="rounded-3xl p-6 sm:p-8" style={{ background: "var(--brass-light)", border: "1px solid var(--accent-glow)" }}>
        <div className="flex items-start gap-4">
          <span className="grid place-items-center w-12 h-12 rounded-2xl shrink-0" style={{ background: "var(--accent)", color: "#fff" }}>
            <Flower2 size={24} />
          </span>
          <div className="min-w-0">
            <h3 className={`${fontClass()} text-xl sm:text-2xl font-bold`} style={{ color: "var(--text)" }}>{t("meheni_title")}</h3>
            <p className="font-ui text-sm sm:text-base mt-1 leading-relaxed" style={{ color: "var(--text-2)" }}>{t("meheni_note")}</p>
          </div>
        </div>
        {list.length > 0 && (
          <div className="space-y-3 mt-5">
            {list.map((song) => {
              const idx = songs.findIndex((s) => s.id === song.id);
              return <SongRow key={song.id} song={song} index={idx} list={songs} />;
            })}
          </div>
        )}
      </div>
    </section>
  );
};
